import React from 'react';

// eslint-disable-next-line max-len
const WILDFUSION_LOGO = '/themes/theme/wildfusion/logo.png';

const WILDFUSIONTheme = {
  headerLogo: {
    src: WILDFUSION_LOGO,
    alt: 'WILDFUSION Logo',
    size: 30,
  },
  darkLogo: {
    src: WILDFUSION_LOGO,
    alt: 'WILDFUSION Logo',
    size: 30,
  },
  linkStyle: {
    color: '#326598',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #326598',
    height: 80,
  },
  title: 'Wild Fusion',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        width="80%"
        src={WILDFUSION_LOGO} alt="WILDFUSION Logo"
      />
      <br /><br />
    </div>
  ),
  shareSite: 'https://share.wildfusions.com',
  isFullWhiteLabel: true,
};

export default WILDFUSIONTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/wildfusion.js
 **/